import keys from '@debbie/common/dist/cache/keys.js';
import { Direction, IncomingState, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import { SocketEvent } from '@debbie/common/dist/web-sockets/index.js';
import * as api from '../api/interactions.js';
import { insightsScopeKey } from '../insights/filter-params.js';
import q from '../query.js';
import { subscribeToEvent } from '../socket.js';
export const interactionsEntity = `interactions`;
export const interactionInsightsTotalsKey = `interaction-insights-totals`;
export const useInteractionInsightsTotals = () => q.query(interactionInsightsTotalsKey, api.getInsightsTotals, keys.read.collection(interactionsEntity));
const callInsightsKey = (from, to) => `interaction-call-insights-${from}-${to}`;
export const useCallInsights = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${callInsightsKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getCallInsights(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const communicationsInsightsKey = (from, to) => `interaction-communications-insights-${from}-${to}`;
export const useCommunicationsInsights = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${communicationsInsightsKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getCommunicationsInsights(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
export const interactionsByReferenceKey = (referenceType, referenceId) => `interaction-by-reference-${referenceType}-${referenceId}`;
export const useInteractionsByReference = (referenceType, referenceId, casualConsistency) => q.query(interactionsByReferenceKey(referenceType, referenceId), () => api.getByReferenceId(referenceType, referenceId), keys.read.collection(interactionsEntity), { enabled: referenceId != null });
export const outgoingInteractionsKey = 'outgoing-interactions';
export const useOutgoingInteractions = () => q.query(outgoingInteractionsKey, () => api.getMultiple({ state: OutgoingState.PENDING, direction: Direction.OUTGOING }, { paused: true }), keys.read.collection(interactionsEntity));
export const incomingInteractionsKey = 'incoming-interactions';
export const useIncomingInteractions = () => q.query(incomingInteractionsKey, () => api.getMultiple({
    state: IncomingState.UNMAPPED,
    direction: Direction.INCOMING,
}), keys.read.collection(interactionsEntity));
// Socket subscription: update q.query cache when new interactions arrive
subscribeToEvent(SocketEvent.NEWINTERACTIONS, (newInteractions) => {
    for (let i = 0; i < newInteractions.length; i++) {
        const interaction = newInteractions[i];
        if (interaction.referenceType && interaction.referenceId) {
            q.mutateCache(interactionsByReferenceKey(interaction.referenceType, interaction.referenceId), (interactions) => {
                if (!interactions) {
                    return interactions;
                }
                const n = [interaction, ...interactions];
                return n.filter((interaction, index) => n.indexOf(interaction) === index);
            });
        }
    }
});
//# sourceMappingURL=index.js.map